import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMedicationStore = defineStore('medication', () => {
  const showSignedOutStudents = ref(false)

  // Trigger for medication list updates
  const medicationListUpdateTrigger = ref(0)

  // Trigger medication list refresh
  const triggerMedicationListUpdate = () => {
    medicationListUpdateTrigger.value++
  }

  return {
    showSignedOutStudents,
    medicationListUpdateTrigger,
    triggerMedicationListUpdate,
  }
})
